<template>
    <BaseLayout :panels="panels" :padding="10" :gutter="10" border-radius>
        <div class="flex-wrap flex-between" style=";z-index:10000;position:absolute;top:0;left:0;right:0;margin:0 auto;height:60px;background:var(--border);">
            <div class="flex-wrap" style="height:100%;">
            <template v-for="v in views">
            <div class="flex-wrap" :key="v.key"  style="height:100%;background:var(--primary);padding:0 10px;color:var(--hover-text);font-size:16px;font-weight:bold;border-right:1px solid var(--border);cursor:pointer;" :style="current_view==v.key?'':'background:var(--hover-text);color:var(--primary);'"  @click="current_view=v.key;panels=dashboards[v.key];__savePageState()">
                <div class="flex-wrap flex-center" style="width:30px;height:30px;border-radius:50%;background:var(--hover-text);margin-right:10px;">
                <BaseIcon color="var(--primary)" :size="25" :icon="v.icon" style="" />
            </div>
                <div >
                    <div>{{ v.name }}</div>
                    <div style="font-size:12px;color:var(--hover);">工作视图</div>
               </div>
               </div>
            </template>
        </div>
            <div class="flex-wrap" style="margin-right:10px;border-left:1px solid var(--border);padding:0 10px;">
            <BaseAvatar :src="session.avatar" :size="40" style="margin-right:10px;" />
            <div>
            <h3>
                <span style="font-weight:normal">你好</span>，{{session.name}}
            </h3>
            <span style="font-weight:normal;color:var(--text2);border-radius:5px;font-size:12px;margin-top:3px;">系统管理员 </span>
            </div>
        </div>

        </div>
    </BaseLayout>
  </template>

<script>
import {mapGetters} from 'vuex';
import mixinPageState from '@/mixins/page_state';
export default {
  mixins: [mixinPageState],
  data() {
    return {
      panels: [],
      views: [],
      current_view: 'my_work',
      pageStateFields: ['current_view'],
    };
  },
  routerOption: {
    as_default: true,
  },
  mounted() {
    this.views = this.def_views;
    this.panels = this.dashboards[this.current_view];
  },
  computed: {
    ...mapGetters('session', ['session']),
    dashboards() {
      return {
        my_work: [{
          x: 0, y: 0.75, w: 12, h: 6, control: 'PanelAiMywork',
        }, {
          x: 0, y: 6.75, w: 12, h: 4.25, control: 'PanelAiProjects',
        }, {
          x: 12, y: 4.75, w: 6, h: 6.25, control: 'PanelAiWorkActivity',
        }, {
          x: 12, y: 0.75, w: 6, h: 4, control: 'PanelAiCalendar',
          styles: ';padding:5px 10px !important;background:var(--border);border-radius:5px;',
          data: {
            hideDate: true,
          },
        }, {
          x: 18, w: 6, y: 0.75, h: 3, control: 'PanelAiMyTool',
        }, {
          x: 18, w: 6, y: 3.75, h: 3, control: 'PanelAiexp',
        }, {
          x: 18, w: 6, y: 6.75, h: 4.25, control: 'PanelAiLink',
        }],
        my_project: [{
          x: 0, y: 0.75, w: 12, h: 6, control: 'PanelAiMywork',
        }, {
          x: 18, w: 6, y: 4.75, h: 6, control: 'PanelEmpty', data: '项目动态',
        }, {
          x: 0, y: 6.75, w: 12, h: 4.25, control: 'PanelEmpty', data: '项目成员',
        }, {
          x: 12, y: 0.75, w: 6, h: 4, control: 'PanelEmpty', data: '项目大事'}, {
          x: 18, y: 0.75, w: 6, h: 4, control: 'PanelAiMyTool',
        }, {
          x: 12, y: 4.75, w: 6, h: 6.25, control: 'PanelAiWorkActivity',
        }],
        my_department: [{
          x: 0, y: 0.75, w: 10, h: 10.25, control: 'PanelEmpty',
          data: '项目情况',
        }, {
          x: 18, w: 6, y: 0.75, h: 6, control: 'PanelEmpty', data: 'AI工具',
        }, {
          x: 10, w: 8, y: 4.75, h: 6.25, control: 'PanelEmpty', data: '人员情况',
        }, {
          x: 10, w: 8, y: 0.75, h: 4, control: 'PanelEmpty', data: '经营情况',
        }, {
          x: 18, w: 6, y: 6.75, h: 4.25, control: 'PanelEmpty', data: '工作动态',
        }],
        my_platform: [{
          x: 0, y: 0.75, w: 12, h: 2, control: 'PanelEmpty', data: '用户登录数据',
        }, {
          x: 0, y: 2.75, w: 4, h: 4, control: 'PanelEmpty', data: '功能热度排名',
        }, {
          x: 4, y: 2.75, w: 4, h: 4, control: 'PanelEmpty', data: '模块热度排名',
        }, {
          x: 8, y: 2.75, w: 4, h: 4, control: 'PanelEmpty', data: '各事业部使用情况',
        }, {
          x: 12, y: 0.75, w: 6, h: 6, control: 'PanelEmpty', data: '服务器状态',
        }, {
          x: 12, y: 6.75, w: 6, h: 4.25, control: 'PanelEmpty', data: '预警信息',
        }, {
          x: 18, w: 6, y: 0.75, h: 6, control: 'PanelEmpty', data: '常用工具',
        }, {
          x: 18, w: 6, y: 6.75, h: 4.25, control: 'PanelAiexp',
        }, {
          x: 0, w: 6, y: 6.75, h: 4.25, control: 'PanelEmpty', data: '需求汇总',
        }, {
          x: 6, w: 6, y: 6.75, h: 4.25, control: 'PanelEmpty', data: 'BUG修复',
        }],

      };
    },
    def_views() {
      return [{name: '我的工作台', icon: 'md-clock', key: 'my_work'}, {name: '项目部管理', icon: 'Building-', key: 'my_project'}, {name: '事业部管理', icon: 'organization', key: 'my_department'}, {name: '平台管理', icon: 'md-cube', key: 'my_platform'}];
    },
    def_panels() {
      return [{
        x: 0, y: 0, w: 6, h: 3, control: 'PanelCNotices', data: {
          key: 'notice',
          title: '企业通知',
        },
      }, {
        x: 0, y: 3, w: 6, h: 3, control: 'PanelCNotices', data: {
          key: 'notice',
          title: '部门通知',
          icon: 'organization',
        },
      }, {
        x: 0, y: 6, w: 6, h: 5, control: 'PanelAccelerators',
      }, {
        x: 6, y: 0, w: 12, h: 5, control: 'PanelEmpty', data: '部门计划',
      }, {
        x: 6, y: 5, w: 12, h: 6, control: 'PanelGroups',
      }, {
        x: 18, y: 0, w: 6, h: 4, control: 'PanelCalendar',
      }, {
        x: 18, y: 4, w: 6, h: 7, control: 'PanelTasks',
      }];
    },
  },
};
</script>

